import React, { useState } from 'react'
import dsTheme from '../../constants/design-system/theme.json'
import TogglePlayButton from '../TogglePlayButton'
import DiscountAnimation from '../DiscountAnimation'
import RolloverAnimation from '../../static/images/data-rollover-animation.gif'
import RolloverAnimationPaused from '../../static/images/data-rollover-animation-paused.png'

import { rolloverBodyContent } from './DataRolloverBody.strings'
import { Root, AnimationWrapper, Columns } from './DataRolloverBody.styles'
import BlockContainer from '../styles/BlockContainer'

const { colors } = dsTheme

const DataRolloverBody = () => {
  const [isPaused, togglePlay] = useState(false)

  const handleToggle = () => togglePlay(!isPaused)

  return (
    <Root>
      <Columns reverse>
        <div>
          <h2 data-testid="data-discount-title">
            {rolloverBodyContent.sectionOne.title}
          </h2>
          {rolloverBodyContent.sectionOne.text}
        </div>
        <AnimationWrapper>
          <TogglePlayButton isPaused={isPaused} onHandleToggle={handleToggle} />
          {!isPaused && <img src={RolloverAnimation} alt="" />}
          {isPaused && <img src={RolloverAnimationPaused} alt="" />}
        </AnimationWrapper>
      </Columns>
      <BlockContainer
        style={{
          backgroundColor: colors['UI/DarkGrey'],
        }}
      >
        <Columns>
          <div>
            <h2 data-testid="data-discount-work-title">
              {rolloverBodyContent.sectionTwo.title}
            </h2>
            {rolloverBodyContent.sectionTwo.text}
          </div>
          <AnimationWrapper>
            <DiscountAnimation size={266} noSpacing />
          </AnimationWrapper>
        </Columns>
      </BlockContainer>
    </Root>
  )
}

export default DataRolloverBody
